export const CONSTANTS = {
  PHONE_TOOL_TIP: {
    TITLE: 'Why is my phone necessary?',
    CONTENT: 'Please provide your primary phone number. If we cannot reach you to verify your account, your transaction may be canceled.',
  },
  DATE_OF_BIRTH_TOOL_TIP: {
    TITLE: 'Why is my date of birth necessary?',
    CONTENT: 'We use this information to validate your member account.',
  },
  PASSWORD_TOOL_TIP: {
    TITLE: 'Password Requirements:',
    CONTENT: 'Must contain 8 or more characters\nMust contain a capital letter\nMust contain a number\nMust contain a special character',
  },
  ERRORS: {
    ACCESS_TOKEN: 'Please enter a valid code in digits',
    REQUIRED: 'This field is required.',
    NAME: 'You have entered an invalid character.',
    DIGIT: 'You have entered an invalid number.',
    MOBILE_PHONE_LENGTH: 'Please enter your 10 digit mobile phone number.',
    EMAIL: 'Please enter a valid email address.',
    PASSWORD_LENGTH: 'Must contain 8 or more characters',
    PASSWORD_SPECIAL_CHARACTER: 'Must contain a special character',
    PASSWORD_CAPITAL_LETTER: 'Must contain a capital letter',
    PASSWORD_NUMBER: 'Must contain a number',
    PASSWORD_CONFIRMATION: 'Your passwords don’t match. Please try again.',
    DATE: 'Please enter a valid date.',
  },
};
